module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Szczegóły pola",
      "before-close": _vm.handleClose,
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "language-switcher"
  }, [_c('form-language-switcher')], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.formCopy,
      "label-width": "100px"
    }
  }, [(_vm.formCopy.resourcetype !== 'TextField') ? _c('base-field', {
    attrs: {
      "form": _vm.formCopy,
      "errors": _vm.errors
    },
    on: {
      "update:form": function($event) {
        _vm.formCopy = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c(_vm.fieldComponent, {
    tag: "component",
    attrs: {
      "form": _vm.formCopy,
      "errors": _vm.errors
    },
    on: {
      "update:form": function($event) {
        _vm.formCopy = $event
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.cancelForm()
      }
    }
  }, [_vm._v("Anuluj")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("Zatwierdź\n            ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34aa56f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/FieldDialog.vue
// module id = 738
// module chunks = 0